import Head from 'next/head';
import Image from 'next/image';
import React from 'react';

import AnalystHeroLines from '@/assets/images/analyst-hero-lines.svg';
import { Heading, Paragraph } from '@/components/dom/text-elements';
import Button from '@/components/global/button';
import { SITE_NAME, THEMATIC_GENERAL_EMAIL_LINK } from '@/lib/constants';

const PricingPage = () => {
    const titleText = `Pricing | ${SITE_NAME}`;

    const headerText = 'Get months of insights in minutes for your team with our AI-powered research platform.';
    const summaryText =
        'Right now, you can take advantage of “unlimited” queries and 100 results per prompt for Free. Want additional capabilities, access, and functionality? Looking for deeper and broader research? Get in contact with us so we can learn more about your use case and needs.';

    return (
        <>
            <Head>
                <title>{titleText}</title>
                <meta
                    name="description"
                    content={headerText}
                />
            </Head>

            <main>
                <section className="h-96 overflow-hidden sm:h-auto bg-gradient-to-b from-brand-navy-light to-white flex items-stretch justify-between relative after:absolute after:bg-white after:opacity-50 after:w-full after:h-full after:z-10 after:lg:hidden pt-48">
                    <div className="relative w-1/2 lg:w-1/3 shrink">
                        <AnalystHeroLines className="w-full" />
                    </div>

                    <div className="p-6 lg:p-0 text-center w-full lg:w-1/2 max-w-xl absolute h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20 flex flex-col items-center lg:items-center justify-center">
                        <header className="mb-4 lg:mb-6 ">
                            <Heading
                                importance={2}
                                className="max-w-[600px] mb-4 mx-auto"
                            >
                                Get <span className={'text-brand-blue-nu'}>months of insights in minutes</span> for your
                                research team with our <span className={'text-brand-blue-nu'}>AI-powered</span> research
                                platform.
                            </Heading>
                            <Paragraph className="max-w-[600px] font-brand-md">{summaryText}</Paragraph>
                        </header>

                        <Button
                            // TODO: TRACKING
                            type="link"
                            href={THEMATIC_GENERAL_EMAIL_LINK}
                            className="mx-auto min-w-[180px] h-[60px] font-brand-md text-lg"
                            color="blue-yves-wire-transparent"
                            roundedCorners="full"
                        >
                            Contact Us
                        </Button>

                        <div className="flex">
                            <div className="flex justify-center items-center space-x-16 py-28 h-0">
                                <Image
                                    src={'/assets/analyst/gradient-sphere.png'}
                                    alt=""
                                    width={200}
                                    height={200}
                                    className="relative z-10"
                                />

                                <Image
                                    src={'/assets/analyst/gradient-polyhedron.png'}
                                    alt=""
                                    width={200}
                                    height={200}
                                    className="relative z-10"
                                />

                                <Image
                                    src={'/assets/analyst/gradient-spiral.png'}
                                    alt=""
                                    width={200}
                                    height={200}
                                    className="relative z-10"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="relative w-1/2 lg:w-1/3 shrink">
                        <AnalystHeroLines className="absolute w-full rotate-180" />
                    </div>
                </section>
            </main>
        </>
    );
};

PricingPage.layout = 'redesign';

export default PricingPage;
